import CreateAudienceDialog from '../../../CreateAudienceDialog/CreateAudienceDialog';
import { useCallback } from 'react';
import { useLoadAudienceDataQuery } from '../../../hooks/audiences';

const useEditAudience = () => {
    const loadAudienceData = useLoadAudienceDataQuery();

    return useCallback(
        async (audience: any) => {
            const audienceData = await loadAudienceData(audience.id);

            if (!audienceData) {
                return;
            }

            CreateAudienceDialog.openModal({
                audience,
                audienceRules: audienceData.rules
            });
        },
        [loadAudienceData]
    );
};

export default useEditAudience;
